import store from '@/store';

export const MEDIA_TYPE = {
  WEBSITE: 'WEBSITE',
  VIDEO: 'VIDEO',
  YOUTUBE: 'YOUTUBE',
  IMAGE: 'IMAGE',
  SUBMENU: 'SUBMENU',
  SUBVODMENU: 'SUBVODMENU',
  TV: 'TV',
  RADIO: 'RADIO',
  VOD: 'VOD',
  WELCOME: 'WELCOME',
  TV_PREMIUM: 'TV_PREMIUM',
  INPUT_SOURCE: 'INPUT_SOURCE',
  SOURCE_SELECT: 'SOURCE_SELECT',
};

export const TYPE_IDENTIFIER = {
  IFRAME: '#iFrame',
  SUBMENU: '#SubMenu',
  SUBVODMENU: '#SubVodMenu',
  BASICINFOAPP: '#basicInfoApp',
  INPUT_SOURCE: '#inputsource',
  SOURCE_SELECT: '#sourceselect',
};

export default class MediaHandler {
  static assembleWebsiteQuery(element, destination = '/media-player') {
    const searchParams = new URLSearchParams();
    const src = element.url.replace('#iFrame/', '');

    searchParams.set('type', MEDIA_TYPE.WEBSITE);
    searchParams.set('src', src);
    return destination + '?' + searchParams.toString();
  }

  static assembleSocketVideoQuery(element, destination = '/media-player') {
    console.log('EL', element);
    const query = element;
    query.type = MEDIA_TYPE.VIDEO;
    query.src = element.src_url;
    query.controls = false;
    query.autoplay = true;
    if (element.next_action) {
      query.hasNextAction = true;
      store.dispatch('navigation/setNextAction', element.next_action);
    }
    return {
      path: destination,
      query: query,
    };
  }

  static assembleBasicInfoAppImageQuery(
    element,
    destination = '/media-player'
  ) {
    const searchParams = new URLSearchParams();
    const src = element.url.replace('#basicInfoApp/', '');

    searchParams.set('type', MEDIA_TYPE.IMAGE);
    searchParams.set('src', src);
    return destination + '?' + searchParams.toString();
  }

  static assembleSubMenuUrl(item, destination = '/sub-menu') {
    const itemArr = item.url.split('/');
    // const identifier = itemArr[0];
    // console.log(item);
    const widgetId = itemArr[1] || item.id;
    return `${destination}/${widgetId}`;
  }

  static assembleSubVodMenuUrl(item, destination = '/sub-vodmenu') {
    const itemArr = item.url.split('/');
    // const identifier = itemArr[0];
    // console.log(item);
    const widgetId = itemArr[1] || item.id;
    return `${destination}/${widgetId}`;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/MediaHandler.js